<template>
  <div v-if="visibleEvents.length != 0" class="netflix-main-container">
    <div class="netflix-title">{{ title }}</div>
    <div class="netflix-show-all" v-if="this.canScrollRight" @click="showAllEvents">Visa alla</div>
    <div class="netflix-container">
      <div class="netflix-scroll">
        <div class="scroll-container" ref="scrollContainer">

          <div class="card" v-for="(item, index) in visibleEvents" :key="index" @click="goToDetails(item.id)">
            <div class="card-container">
              <img :src="item.imageUrl" :alt="item.title" class="card-image" v-if="item.imageUrl" />
              <div v-else class="card-placeholder">Image not available</div>
              <div class="city-text">{{ item.city }}</div>
            </div>
            <div class="card-content">
              <h3 class="card-title">{{ item.title }}</h3>
              <div class="card-container">
                <p class="card-rating">
                  <i class="fas fa-map-marker-alt icon"></i>
                  {{ item.street }}
                </p>
                <p class="card-rating">
                  <i class="fas fa-clock icon"></i>
                  <span class="date-text">{{ formatDate(item.startDate) }} {{ formatTime(item.startTime) }}</span>
                </p>
              </div>
              <div class="card-platforms">
                <span v-for="platform in item.platforms" :key="platform" class="platform">
                  {{ platform }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <button class="scroll-left" @click="scrollLeft" v-if="canScrollLeft && !isMobile">
        <i class="fa fa-chevron-circle-left fa-2xl" aria-hidden="true"></i>
      </button>
      <button class="scroll-right" @click="scrollRight" v-if="canScrollRight && !isMobile">
        <i class="fa fa-chevron-circle-right fa-2xl" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { toRaw } from "vue";
import AxiosInstance from "../api/axios";
import EventResponse from "../aggrigates/events/models/EventResponse.js";
// import localStorageService from "../localStorageService/localStorageService.js";
// import HeartIcon from "../components/HeartIcon.vue";
import { EventBus } from '../api/EventBusMixin';
// import BadgeComponent from "../components/BadgeComponent.vue";
// import EventlyScroll from "../components/EventlyScroll.vue"
export default {
  // components: { HeartIcon },
  props: {
    title: { type: String, required: true },
    apiUrl: { type: String, required: true },
    // cacheName: { type: String, required: true },
    options: {
      type: Object,
      default: () => ({ miniCard: true }),
      required: true,
    },
  },
  data() {
    return {
      isMobile: false,
      canScrollLeft: false,
      canScrollRight: false,
      isLoading: false,
      allEventsIsLoaded: false,
      hasError: false,
      events: [], // All events from the API
      visibleEvents: [], // Events currently visible in the grid
      pageNumber: 0,
      localApiUrl: null
      // localyCacheName: null
    };
  },
  async mounted() {
    // this.localyCacheName = this.cacheName;
    this.localApiUrl = this.apiUrl;
    // await this.fetchEvents();
    this.watchScroll();
    this.checkMobile();
    this.checkScrollButtons();
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  watch: {
    // cacheName: {
    //   immediate: true, // Run this when the component mounts
    //   handler(newCacheName) {
    //     this.localyCacheName = newCacheName;
    //     this.resetComponent();
    //     this.fetchEvents();
    //   },
    // },
    apiUrl: {
      immediate: true, // Run this when the component mounts
      handler(apiUrl) {
        this.localApiUrl = apiUrl;
        this.resetComponent();
        this.fetchEvents();
      },
    },
    // Watch for changes in events to update scroll button visibility
    events: function () {
      this.checkScrollButtons();
    },
  },
  methods: {
    watchScroll() {
      const container = this.$refs.scrollContainer;
      if (container) {
        // Add an event listener to detect scrolling
        container.addEventListener('scroll', () => {
          const scrollPosition = container.scrollLeft; // Current horizontal scroll position
          const totalScrollWidth = container.scrollWidth - container.clientWidth; // Total scrollable width
          const scrolledPercentage = (scrollPosition / totalScrollWidth) * 100;

          if (scrolledPercentage >= 85) {
            this.fetchEvents()
            // Take any action here (e.g., load more content, trigger animations)
          }
        });
      }
    },
    resetComponent() {
      this.events = [];
      this.visibleEvents = [];
      this.pageNumber = 0;
      this.allEventsIsLoaded = false;
      this.hasError = false;
      this.isLoading = false;
    },
    goToDetails(id) {
      window.location.href = `/eventdetails/${id}`;
    },
    handleToggleHeart(item, newValue) {
      /* eslint-disable */
      if (!this.$isLoggedIn()) {
        EventBus.emit('accountModal', { open: 'login-account' });
      }
      else {
        if (item.liked) {
          EventBus.emit("un-event-like", item.id);
        }
        else {
          EventBus.emit("event-like", item.id);
        }
        item.liked = newValue;
      }
    },
    async fetchEvents() {
      if (this.isLoading || this.allEventsIsLoaded) {
        return;
      }
      if(!this.localApiUrl)
      {return;}
      this.isLoading = true;
      this.hasError = false;

      try {
        
        const eventResponse = new EventResponse();
        // const cachedEvents = localStorageService.get(this.localyCacheName + "-" + this.pageNumber);
        // if (cachedEvents) {
        //   this.events = cachedEvents;
        //   this.loadMoreEvents();
        //   if (this.pageNumber % 2 !== 0) {
        //     await this.fetchEvents();
        //   }
        //   return;
        // }

        const response = await AxiosInstance.get(this.localApiUrl + this.pageNumber);
        eventResponse.fromResponse(response.data);

        if (eventResponse.items.length === 0) {
          this.allEventsIsLoaded = true;
          return;
        }

        this.pageNumber++;
        this.events = toRaw(eventResponse.items);
        // localStorageService.set(this.localyCacheName + "-" + this.pageNumber, this.events, 4);

        this.loadMoreEvents();
      } catch (error) {
        console.error("Error fetching events:", error);
        this.hasError = true;
      } finally {
        if (this.pageNumber % 2 !== 0) {
          await this.fetchEvents();
        }
        this.isLoading = false;
      }
    },
    loadMoreEvents() {
      const newEvents = toRaw(this.events);
      if (newEvents.length > 0) {
        this.visibleEvents.push(...newEvents);
      }
    },
    handleResize() {
      this.checkMobile();
      this.checkScrollButtons();
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 568;
    },
    scrollLeft() {
      const container = this.$refs.scrollContainer;
      if (container) {
        const cardWidth = container.scrollWidth / this.events.length;
        container.scrollBy({ left: -cardWidth * 5, behavior: 'smooth' }); // Scroll by 2 cards
        if (container.scrollLeft == 0) {
          this.canScrollLeft = false;
        }
      }
    },
    scrollRight() {
      const container = this.$refs.scrollContainer;
      if (container) {
        const cardWidth = container.scrollWidth / this.events.length;
        container.scrollBy({ left: cardWidth * 5, behavior: 'smooth' }); // Scroll by 2 cards
      }
      this.canScrollLeft = true;
    },
    checkScrollButtons() {
      this.$nextTick(() => {
        const container = this.$refs.scrollContainer;
        if (container) {
          const maxScroll = container.scrollWidth - container.clientWidth;
          this.canScrollLeft = container.scrollLeft > 0;
          this.canScrollRight = container.scrollLeft < maxScroll;
        }
      });
    },
    formatDate(dateString) {
      const now = new Date(); // Current date and time
      const inputDate = new Date(dateString); // Convert the input string to a Date object

      // Check if the input date is today
      if (
        inputDate.getFullYear() === now.getFullYear() &&
        inputDate.getMonth() === now.getMonth() &&
        inputDate.getDate() === now.getDate()
      ) {
        return 'Idag';
      }

      // Calculate the difference in days
      const differenceInTime = inputDate.getTime() - now.getTime();
      const differenceInDays = Math.ceil(differenceInTime / (1000 * 60 * 60 * 24)); // Convert to days

      // If the date is within the next week
      if (differenceInDays > 0 && differenceInDays <= 7) {
        return `Om ${differenceInDays} dagar`;
      }

      // Otherwise, format it as YYYY-MM-DD
      return dateString.split('T')[0];
    },
    formatTime(timeString) {
      var time = timeString.split(':').slice(0, 2).join(':');
      if (time == "00:00") {
        return "";
      }
      return time;
    },
    showAllEvents() {
      this.$emit('show-all-events', { title: this.title, endPoint: this.localApiUrl });
    }
  },
};
</script>

<style scoped>
.icon {
  margin-right: 5px !important;
}

.fa-clock {
  position: relative;
  right: 1px !important;
}

.fa-chevron-circle-left,
.fa-chevron-circle-right {
  font-size: 25px !important;
  color: #ddd;
}


/* Responsive Height for Netflix Scroll */
@media (min-width: 1400px) {
  .card {
    height: 300px !important;
  }

  .fa-chevron-circle-left,
  .fa-chevron-circle-right {
    font-size: 35px;
    /* Smaller size for tablets or medium screens */
  }
}

@media (max-width: 1200px) {
  .card {
    width: calc(100% / 4 - 15px);
    max-width: calc(100% / 4 - 15px);
    height: 250px !important;
  }
}

@media (max-width: 768px) {
  .card {
    width: calc(100% / 3 - 15px);
    max-width: calc(100% / 3 - 15px);
    height: 200px !important;
  }

  .fa-chevron-circle-left,
  .fa-chevron-circle-right {
    font-size: 28px;
  }
}

@media (max-width: 480px) {
  .card {
    width: calc(100% / 2 - 15px);
    max-width: calc(100% / 2 - 15px);
    height: 180px !important;
  }

  .fa-chevron-circle-left,
  .fa-chevron-circle-right {
    font-size: 18px;
  }
}

/* Left and Right navigation buttons */
.scroll-left {
  float: left;
  left: 17px;
  /* left: 1%; */
}

.scroll-right {
  float: right;
  right: 20px;
  /* right: 45px; */
}

/* Navigation buttons for scrolling */
.scroll-left,
.scroll-right {
  position: relative;
  top: 25px;
  /* top: 110%; */
  transform: translateY(-50%);
  background-color: transparent;
  border: none;
  /* 0px solid #ddd; */
  /* border-radius: 50%; */
  width: 40px;
  height: 40px;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); */
  z-index: 10;
}

.netflix-main-container {
  padding-top: 50px;
  position: relative;
  left: 10px;
}

.netflix-title {
  color: white;
  padding-left: 20px !important;
  font-size: 15px !important;
  white-space: nowrap;
  display: inline;
}

.netflix-show-all {
  position: absolute;
  right: 24px;
  color: white;
  font-size: 12px;
  white-space: nowrap;
  display: inline;
  cursor: pointer;
}

.netflix-container {
  position: relative;
  width: 100%;
  display: flex;
  padding-left: 20px;
  height: 100%;
  /* Make sure the container matches the height of the scroll area */
  margin-bottom: 0;
  /* Remove any extra space at the bottom */
}

.netflix-scroll {
  position: relative;
  padding-right: 20px;
  display: flex;
  align-items: center;
  width: 100%;
  overflow: hidden;
  height: 100%;
  /* Ensure it fills the container */
}

.scroll-container {
  display: flex;
  overflow-x: scroll;
  width: 100%;
  scrollbar-width: none;
  scroll-behavior: smooth;
  gap: 15px;
  /* height: 100%; */
  /* Ensure the scroll container matches the height */
}

.card {
  width: calc(100% / 5.5 - 15px);
  max-width: calc(100% / 5.5 - 15px);
  box-sizing: border-box;
  background-color: rgba(0, 0, 0, 0.3);
  /* #413735; */
  display: flex;
  flex-direction: column;
  height: 300px;
  /* Set your desired height */
  overflow: hidden;
  /* Ensure corners are covered */
  border-radius: 10;
  /* Remove rounded corners if necessary */
  border: none;
  cursor: pointer;
}

.scroll-container::-webkit-scrollbar {
  display: none;
}

/* Cards inside the scrollable container */
.scroll-container>* {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  /* Ensure each card fills the container height */
}

/* .scroll-left:hover,
.scroll-right:hover {
  background-color: #f0f0f0;
} */

/* .card-image {
  width: 100%;
  object-fit: fill;
} */
.card-image {
  width: 100%;
  height: auto;
  object-fit: fill;
  /* Make the image cover the entire container */
  display: block;
}

.city-text {
  position: absolute;
  bottom: 1px;
  right: 1px;
  color: white;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.5);
  padding: 5px 10px;
  border-radius: 5px;
}

.card-placeholder {
  width: 100%;
  height: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f0f0;
  color: #999;
  font-size: 14px;
}

.card-content {
  padding: 10px;
  flex-grow: 1;
  overflow: hidden;
}

.card-title {
  font-size: 16px;
  margin: 0 0 5px;
  color: white;
}

.card-container {
  /* margin-top: 7%; */
  position: relative;
  display: inline-block;
}

.card-rating {
  font-size: 10px;
  font-weight: 600;
  color: white;
  margin-bottom: 5px;
}

.card-platforms {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  color: white;
}

.platform {
  font-size: 10px;
  background-color: #f0f0f0;
  padding: 3px 8px;
  border-radius: 8px;
}

@media (min-width: 1400px) {
  .card {
    width: calc(100% / 5.1 - 15px);
    max-width: calc(100% / 5.1 - 15px);
    height: 16rem !important;
  }

  .card-image {
    height: 9.5rem !important;
  }

  .card-rating {
    font-size: 10px !important;
  }

  .card-title {
    font-size: 11px !important;
  }

  .netflix-title {
    color: white;
    padding-left: 23px;
    font-size: 20px;
    white-space: nowrap;
    display: inline;
  }
}

@media (max-width: 1399px) {
  .card {
    width: calc(100% / 4.2 - 15px);
    max-width: calc(100% / 4.2 - 15px);
    height: 16rem !important;
    /* background-color: aquamarine; */
  }

  .card-image {
    height: 9.5rem !important;
  }

  .card-rating {
    font-size: 10px !important;
  }

  .card-title {
    font-size: 11px !important;
  }

  .netflix-title {
    color: white;
    padding-left: 23px;
    font-size: 20px;
    white-space: nowrap;
    display: inline;
  }
}

@media (max-width: 1241px) {
  .card {
    width: calc(100% / 4.2 - 15px);
    max-width: calc(100% / 4.2 - 15px);
    height: 16rem !important;
    /* background-color: aquamarine; */
  }

  .card-image {
    height: 9.5rem !important;
  }

  .card-rating {
    font-size: 10px !important;
  }

  .card-title {
    font-size: 11px !important;
  }

  .netflix-title {
    color: white;
    padding-left: 23px;
    font-size: 20px;
    white-space: nowrap;
    display: inline;
  }
}

@media (max-width: 1100px) {
  .card {
    width: calc(100% / 3.5 - 15px);
    max-width: calc(100% / 3.5 - 15px);
    height: 16rem !important;
  }

  .card-image {
    height: 9rem !important;
  }

  .card-rating {
    font-size: 10px !important;
  }

  .card-title {
    font-size: 11px !important;
  }

  .netflix-title {
    color: white;
    padding-left: 23px;
    font-size: 15px;
    white-space: nowrap;
    display: inline;
  }
}

@media (max-width: 768px) {
  .card {
    width: calc(100% / 2.5 - 15px);
    max-width: calc(100% / 2.5 - 15px);
    height: 14rem !important;
  }

  .card-image {
    height: 7rem !important;
  }

  .card-rating {
    font-size: 9px !important;
  }

  .card-title {
    font-size: 10px !important;
  }

  .netflix-title {
    color: white;
    padding-left: 23px;
    font-size: 14px;
    white-space: nowrap;
    display: inline;
  }
}

@media (max-width: 480px) {
  .card {
    width: calc(100% / 2.1 - 15px);
    max-width: calc(100% / 2.1 - 15px);
    height: 12rem !important;
  }

  .card-image {
    height: 7rem !important;
  }

  .card-rating {
    font-size: 8px !important;
  }

  .card-title {
    font-size: 9px !important;
  }

  .netflix-title {
    color: white;
    padding-left: 23px;
    font-size: 13px !important;
    white-space: nowrap;
    display: inline;
  }

  .netflix-main-container {
    position: relative;
    left: 0px;
  }
}

@media (max-width: 380px) {
  .card {
    width: calc(100% / 1.8 - 15px);
    max-width: calc(100% / 1.8 - 15px);
    height: 11rem !important;
  }

  .card-image {
    height: 5rem !important;
  }

  .card-rating {
    font-size: 8px !important;
  }

  .card-title {
    font-size: 9px !important;
  }

  .netflix-title {
    color: white;
    padding-left: 23px;
    font-size: 13px !important;
    white-space: nowrap;
    display: inline;
  }

  .netflix-main-container {
    position: relative;
    left: 0px;
  }
}
</style>
